<template>
  <div>
    <div class="row">
      <label class="control-label">Suche nach Bestellnummer:</label>
      <div class="col-md-9 mar-bot">
        <input
          v-model="searchModel"
          type="text"
          @input="filterOrders"
        />
      </div>
    </div>
    <div class="row">
      <table class="table mRight table-ex">
        <thead class="table-header">
          <tr>
            <th
              class="table-header"
              width="70"
            >
              #
            </th>
            <th class="table-header">
              Bestellnummer
            </th>
            <th class="table-header">
              Preis (incl. USt 19%)
            </th>
            <th
              class="table-header"
              width="100"
            >
              Vollmacht
            </th>
            <th class="table-header">
              Bemerkung
            </th>
            <th class="table-header">
              Bestellt am
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="order in orderList"
            :key="order.id"
            class="table-row"
            :class="{ picked: pickedOrder.id === order.id}"
            @click="pick(order)"
          >
            <th width="70">
              {{ order.id }}
            </th>
            <td>{{ order.order_number }}</td>
            <td>{{ order.b_price }} €</td>
            <td
              v-if="order.mandate"
              width="80"
            >
              Ja
            </td>
            <td
              v-if="!order.mandate"
              width="80"
            >
              Nein
            </td>
            <td>{{ order.note }}</td>
            <td>{{ order.created_at }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <OrderPreview :order="pickedOrder"></OrderPreview>
  </div>
</template>
<script>
import OrderPreview from '../components/OrderPreview.vue'
export default {
  components: {
    OrderPreview
  },
  data () {
    return {
      orders: [],
      pickedOrder: {},
      searchModel: '',
      filteredOrders: []
    }
  },
  computed: {
    orderList () {
      if (this.filteredOrders.length > 0) {
        return this.filteredOrders
      } else {
        return this.orders
      }
    }
  },
  mounted () {
    this.$axios.get(process.env.VUE_APP_BASE_URI + 'sadmin/orders')
      .then((response) => {
        this.orders = []
        var ord = response.data
        var ordId = localStorage.getItem('order_id')
        ord.forEach(order => {
          if (order.delivered_at === null) {
            if (localStorage.getItem('order_id')) {
              if (order.id === ordId) {
                this.pickedOrder = order
              }
            }
            this.orders.push(order)
          }
        })
      })
  },
  methods: {
    pick (order) {
      localStorage.setItem('order_id', order.id)
      this.pickedOrder = order
    },
    filterOrders () {
      var filteredList = []
      this.orders.forEach(order => {
        for (var i = 0; i < this.searchModel.length; i++) {
          if (order.order_number.toLowerCase().charAt(i) === this.searchModel.toLowerCase().charAt(i)) {
            if (i === this.searchModel.length - 1) {
              // MATCH
              filteredList.push(order)
            }
          } else {
            break
          }
        }
      })
      this.filteredOrders = filteredList
    }
  }
}
</script>
<style>
</style>
